import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const EditSubnetPage = lazy(
  () => import('@/features/Network/pages/EditSubnetPage'),
)

export const Route = createFileRoute('/infra/network/edit-subnet/$subnetId')({
  beforeLoad: protectedRouteGuard,
  loader: () => ({
    crumb: 'Edit Subnet',
  }),
  component: () => (
    <Suspense fallback={<Loading />}>
      <EditSubnetPage />
    </Suspense>
  ),
})
